import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-pressed", "data-testid"]
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-4 h-4",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_3 = ["d"]
const _hoisted_4 = { class: "text-lg text-textPrimary font-bold" }
const _hoisted_5 = {
  class: "text-left text-3xl font-bold text-textPrimary",
  "data-testid": "summary-card-count"
}

import { computed } from 'vue'
import { mdiLock, mdiLockOpenVariant } from '@mdi/js'
import { ExceptionStatusEnum } from '@/Network/Types/Requests/DoctorStationExceptionRequests'

// Inativo: borda cinza. Ativo (status na seleção do filtro): borda + fundo claro na cor do status.
interface StatusConfig {
  border: string
  activeBackground: string
  textColor: string
  icon: string
  label: string
  key: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ExceptionalitySummaryCard',
  props: {
    status: {},
    count: {},
    active: { type: Boolean }
  },
  emits: ["toggle"],
  setup(__props: any, { emit }) {

const props = __props;





// Classes completas (sem interpolar) para o JIT do Tailwind enxergá-las.
const STATUS_MAP: Record<string, StatusConfig> = {
  [ExceptionStatusEnum.AWAITING_APPROVAL]: {
    border: 'border-alert',
    activeBackground: 'bg-alert/10',
    textColor: 'text-alert',
    icon: mdiLock,
    label: 'Em andamento',
    key: 'in-progress'
  },
  [ExceptionStatusEnum.APPROVED]: {
    border: 'border-sucess',
    activeBackground: 'bg-sucess/10',
    textColor: 'text-sucess',
    icon: mdiLockOpenVariant,
    label: 'Aprovado',
    key: 'approved'
  },
  [ExceptionStatusEnum.REJECTED]: {
    border: 'border-negative',
    activeBackground: 'bg-negative/10',
    textColor: 'text-negative',
    icon: mdiLock,
    label: 'Recusado',
    key: 'rejected'
  }
}

const DEFAULT_CONFIG: StatusConfig = {
  border: 'border-gray-300',
  activeBackground: 'bg-gray-100',
  textColor: 'text-gray-500',
  icon: mdiLock,
  label: 'Desconhecido',
  key: 'unknown'
}

const config = computed(() => STATUS_MAP[props.status] ?? DEFAULT_CONFIG)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass([
      'rounded-lg border-2 border-solid p-4 flex flex-col gap-3 flex-1 min-w-[180px] text-left cursor-pointer transition hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
      _ctx.active ? [config.value.border, config.value.activeBackground] : 'border-gray-200 bg-white'
    ]),
    "aria-pressed": _ctx.active ? 'true' : 'false',
    "data-testid": `summary-card-${config.value.key}`,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle')))
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["flex w-full items-center gap-1 text-sm font-medium", config.value.textColor])
    }, [
      (_openBlock(), _createElementBlock("svg", _hoisted_2, [
        _createElementVNode("path", {
          d: config.value.icon,
          fill: "currentColor"
        }, null, 8, _hoisted_3)
      ])),
      _createElementVNode("span", _hoisted_4, _toDisplayString(config.value.label), 1)
    ], 2),
    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.count), 1)
  ], 10, _hoisted_1))
}
}

})